import { Flex, Text, Box } from '@common/fundamentals'

export const DetailRow = ({
  label,
  value,
  icon,
  labelWidth = 140,
}: {
  label: string
  value: React.ReactNode
  icon?: React.ReactNode
  labelWidth?: number
}) => (
  <Flex alignItems='center'>
    <Flex alignItems='center' minWidth={labelWidth} sx={{ gap: 0.5 }}>
      {icon}
      <Text color='text.secondary' fontSize={12}>
        {label}
      </Text>
    </Flex>
    <Box flex={1}>
      <Text fontSize={14} component='span'>
        {value}
      </Text>
    </Box>
  </Flex>
)
